import React from 'react'
import DasboardMessages from './Chatting/DasboardMessage.jsx'

const ShopInboxPage = () => {
  return (
    <div>
      <DasboardMessages/>
    </div>
  )
}

export default ShopInboxPage
